// ============================================
// ORDERCONFIRMATION.JS - Página Thank You
// Ruta: /order-confirmation
// Se accede desde CheckoutPage tras completar pedido
// ============================================

import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import SEO from "../components/SEO";
import "./OrderConfirmation.css";

// Íconos SVG
const CheckIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" width="28" height="28">
    <path d="M5 13l4 4L19 7" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const MailIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="18" height="18">
    <rect x="2" y="4" width="20" height="16" rx="2" />
    <path d="M2 8l10 6 10-6" />
  </svg>
);

const BoxIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="18" height="18">
    <path d="M21 8V19a2 2 0 01-2 2H5a2 2 0 01-2-2V8" />
    <path d="M1 3h22v5H1z" />
    <path d="M10 12h4" strokeLinecap="round" />
  </svg>
);

const TruckIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="18" height="18">
    <path d="M1 3h15v13H1zM16 8h4l3 3v5h-7V8z" />
    <circle cx="5.5" cy="18.5" r="2.5" />
    <circle cx="18.5" cy="18.5" r="2.5" />
  </svg>
);

export default function OrderConfirmation() {
  const navigate = useNavigate();
  const location = useLocation();

  // Datos del pedido — vienen del state de navigate() en CheckoutPage
  // navigate("/order-confirmation", { state: { orderData } })
  const orderData = location.state?.orderData || {
    orderNumber: `PHY-${Math.floor(100000 + Math.random() * 900000)}`,
    email: "tu@correo.com",
    firstName: "Cliente",
    items: [],
    total: 0,
    estimatedDelivery: "3-5 días hábiles",
  };

  // Generar número de orden si no viene
  const orderNumber = orderData.orderNumber || `PHY-${Math.floor(100000 + Math.random() * 900000)}`;

  // Scroll al top al entrar
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div className="oc-root">
      <SEO title="Pedido confirmado" description="Confirmación de tu pedido Physiology Skincare Co." noindex />
      <div className="oc-container">

        {/* Ícono de confirmación */}
        <div className="oc-check-wrap">
          <div className="oc-check-circle">
            <CheckIcon />
          </div>
        </div>

        {/* Título */}
        <p className="oc-eyebrow">Pedido confirmado</p>
        <h1 className="oc-title">¡Gracias por tu compra!</h1>
        <p className="oc-subtitle">
          Tu pedido ha sido procesado exitosamente.<br />
          Pronto recibirás noticias tuyas.
        </p>

        {/* Card número de orden */}
        <div className="oc-order-card">
          <div className="oc-order-row">
            <span className="oc-order-label">Número de pedido</span>
            <span className="oc-order-value">{orderNumber}</span>
          </div>
          <div className="oc-order-divider" />
          <div className="oc-order-row">
            <span className="oc-order-label">Entrega estimada</span>
            <span className="oc-order-value">{orderData.estimatedDelivery || "3-5 días hábiles"}</span>
          </div>
        </div>

        {/* Notificación de correo */}
        <div className="oc-email-notice">
          <MailIcon />
          <p>
            Enviamos la confirmación de tu pedido a{" "}
            <strong>{orderData.email}</strong>.{" "}
            Revisa tu bandeja de entrada o spam.
          </p>
        </div>

        {/* Pasos del pedido */}
        <div className="oc-steps">
          <div className="oc-step oc-step--done">
            <div className="oc-step-icon">
              <CheckIcon />
            </div>
            <div className="oc-step-info">
              <p className="oc-step-title">Pedido recibido</p>
              <p className="oc-step-desc">Tu pedido fue confirmado</p>
            </div>
          </div>

          <div className="oc-step-connector" />

          <div className="oc-step oc-step--pending">
            <div className="oc-step-icon">
              <BoxIcon />
            </div>
            <div className="oc-step-info">
              <p className="oc-step-title">Preparando envío</p>
              <p className="oc-step-desc">Empacando tu pedido</p>
            </div>
          </div>

          <div className="oc-step-connector" />

          <div className="oc-step oc-step--pending">
            <div className="oc-step-icon">
              <TruckIcon />
            </div>
            <div className="oc-step-info">
              <p className="oc-step-title">En camino</p>
              <p className="oc-step-desc">Recibirás tu tracking por correo</p>
            </div>
          </div>
        </div>

        {/* Divisor */}
        <div className="oc-divider" />

        {/* Acciones */}
        <div className="oc-actions">
          <button
            className="oc-btn-primary"
            onClick={() => navigate("/shop")}
          >
            Seguir comprando
          </button>
          <button
            className="oc-btn-secondary"
            onClick={() => navigate("/account")}
          >
            Ver mis pedidos
          </button>
        </div>

        {/* Nota final */}
        <p className="oc-note">
          ¿Tienes dudas sobre tu pedido?{" "}
          <button className="oc-contact-link" onClick={() => navigate("/")}>
            Contáctanos
          </button>
        </p>

      </div>
    </div>
  );
}
